module.exports = __webpack_public_path__ + "static/media/line-double.02fef9ec.svg";